class AccordionCustom extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.querySelector('.custom-accordion');
    this.button = this.querySelector('.custom-accordion-header');
    this.content = this.querySelector('.details-content');

    if (!this.wrapper || !this.button || !this.content) return;

    this.button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const isOpen = this.wrapper.classList.contains('is-open');

    this.wrapper.classList.toggle('is-open', !isOpen);
    this.button.setAttribute('aria-expanded', String(!isOpen));

    if (!isOpen) {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      this.content.style.opacity = '1';
    } else {
      this.content.style.maxHeight = '0px';
      this.content.style.opacity = '0';
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}